import {useState, useEffect} from 'react';

/**
 * Custom hook to get current scroll position
 * @return {{width: undefined, height: undefined}}
 */
export default function useScrollPos() {
  const [windowScrollPos, setWindowScrollPos] = useState({
    top: undefined,
    left: undefined,
  });

  useEffect(() => {
    /**
         * Handler to call on window scroll
         */
    function handleScroll() {
      // Set window width/height to state
      setWindowScrollPos({
        top: document.documentElement.scrollTop ||
            window.pageYOffset ||
            document.body.scrollTop,
        left: document.documentElement.scrollLeft ||
            window.pageXOffset ||
            document.body.scrollLeft,
      });
    }
    // Add event listener
    window.addEventListener('scroll', handleScroll);
    // Call handler right away so state gets updated with initial window size
    handleScroll();
    // Remove event listener on cleanup
    return () => window.removeEventListener('scroll', handleScroll);
  }, []); // Empty array ensures that effect is only run on mount
  return windowScrollPos;
}
